var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { proxyApi } from './';
/**
 * 宽虚热吧 的代理接口
 * @export
 * @param {string} target 请求路由
 * @param {*} [data] 请求参数
 */
export function leadApi(target, data) {
    return __awaiter(this, void 0, void 0, function* () {
        return (yield proxyApi({ module: 'lead', target, data })).detail;
    });
}
/** 列表排序的3个维度
 * @remarks 同一类型的排序方式不允许同时出现多次，例如[CreateTimeDesc, CreateTimeAsc]
 * @examples [CreateTimeDesc, UpdateTimeAsc] 先按创建时间倒序排序，再按更新时间正序排序
*/
export var LeadsSorts;
(function (LeadsSorts) {
    /** 创建时间倒序 */
    LeadsSorts[LeadsSorts["CreateTimeDesc"] = 1] = "CreateTimeDesc";
    /** 创建时间正序 */
    LeadsSorts[LeadsSorts["CreateTimeAsc"] = 2] = "CreateTimeAsc";
    /** 营销线索分数倒序 */
    LeadsSorts[LeadsSorts["ScoresDesc"] = 4] = "ScoresDesc";
    /** 营销线索分数正序 */
    LeadsSorts[LeadsSorts["ScoresAsc"] = 8] = "ScoresAsc";
    /** 更新时间倒序 */
    LeadsSorts[LeadsSorts["UpdateTimeDesc"] = 16] = "UpdateTimeDesc";
    /** 更新时间正序 */
    LeadsSorts[LeadsSorts["UpdateTimeAsc"] = 32] = "UpdateTimeAsc";
})(LeadsSorts || (LeadsSorts = {}));
/**
 * 获取由本人生成的联系人列表
 * @remarks `mql`是否包含营销线索相关数据
 * @param {({ isLead?: boolean, sorts?: Array<LeadsSorts>,  mql?: boolean } & ListPagination)}
 */
export function getLeads(params) {
    return leadApi('GetLeads', params);
}
/**
 * 搜索由本人生成的联系人列表
 * @param {string} field 搜索字段
 * @param {string} keyword 搜索值
 * @param {({ isLead?: boolean, sorts?: Array<LeadsSorts>, tagId: string, mql?: T } & ListPagination)} params
 */
export function searchLeads(field, keyword, params) {
    return leadApi('SearchLeads', Object.assign({ field, keyword }, params));
}
/**
 * 获取联系人详情
 * @param {string} leadId 联系人id
 * @param {{ fields?: string[], tag?: K, mql?: T, scoreDimension?: P }} params
 */
export function getLead(leadId, params) {
    return leadApi('GetLead', Object.assign({ leadId }, params));
}
/**
 * 更新联系人
 * @param {{ lead: string, source: { sourceType: string, sourceDescribe: string }, referrerType?: LeadReferrerType, referrerId?: string, properties: Record<string, string> }} params
 */
export function updateLead(params) {
    return leadApi('UpdateLead', params);
}
/**
 * 获取联系人字段列表
 */
export function getLeadFields() {
    return leadApi('GetFields');
}
